export default __webpack_public_path__ + "static/ourservise-a7b239dc6f525acdf3af335e0776fbde.png";